// ======================================================================
// File Name       : AdaptiveBatchHistory
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col } from 'react-bootstrap';
import TableHead from '../../components/TableHead';
import { parseDateForDetail, isIE, parseImportHistory } from '../../utils/index';
import ReduxFormPaging from '../../components/ReduxFormPaging';
import { CSV_REGISTRATION_STATUS } from '../../constants/index';

const thead = [
  { title: 'No', sortBy: null, width: 50 },
  { title: 'ファイル名', sortBy: 0 },
  { title: 'ステータス', sortBy: 1, width: 115 },
  { title: '開始時間', sortBy: 2, width: 165 },
  { title: '完了時間', sortBy: 3, width: 165 },
  { title: 'エラー件数', sortBy: 4, width: 115 },
  { title: '操作', sortBy: null, width: 120 },
];

class AdaptiveBatchHistory extends React.Component {
  render() {
    const {
      invalid,
      handleSortState,
      startPosition,
      recordNum,
      importResultList,
      getStartEndData,
      onSearchBtnClick,
      onClickDownload,
    } = this.props;
    let tbody = null;
    if (importResultList && importResultList.length) {
      tbody = importResultList.map((result, index) => (
        <tr key={index}>
          <td>{startPosition + index + 1}</td>
          <td>{result.importFileName}</td>
          <td>
            {result.importResultStatus === CSV_REGISTRATION_STATUS.PROCESSED
              ? '処理済'
              : result.importResultStatus === CSV_REGISTRATION_STATUS.PROCESSING ? '処理中' : '処理待ち'}
          </td>
          <td>{parseDateForDetail(result.importStartTime)}</td>
          <td>{parseDateForDetail(result.importEndTime)}</td>
          <td>{parseImportHistory(result.importErrorCount, result.importEndTime)}</td>
          <td className="text-center">
            {result.resultFileUrl ? (
              <Button
                variant="primary"
                className="btn-96"
                id={index}
                onClick={() => {
                  onClickDownload(result.resultFileUrl, result.importFileName);
                }}
              >
                ダウンロード
              </Button>
            ) : null}
          </td>
        </tr>
      ));
    }
    return (
      <div>
        <Col sm={12} className="adaptive-batch-history padding-left-right-clear text-right">
          <Col className="display-inline-block margin-bottom-10 margin-right-20">
            <Button variant="primary" className="btn-96" onClick={onSearchBtnClick}>
              更新
            </Button>
          </Col>
          <Col className="text-right display-inline-block">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
              invalid={invalid}
            />
          </Col>
        </Col>
        <Col sm={12} className="margin-top-10 padding-left-right-clear">
          <Table striped hover>
            <thead>
              <ReduxFormPaging
                type="tableHead"
                data={thead}
                name="importSortType"
                invalid={invalid}
                handleSortState={handleSortState}
              />
            </thead>
            <tbody>{tbody}</tbody>
          </Table>
        </Col>
      </div>
    );
  }
}

export default AdaptiveBatchHistory;
